// extracted by mini-css-extract-plugin
export default {"summaryMetricFacets":"FKDF9r6jHfFPOiJtCOdD","summaryMetricFacet":"_wFC3rlBbs1sUtkV6Qcg"};